import React from 'react';
import Editor from '@monaco-editor/react';
import { Box, Paper, Stack, Typography } from '@mui/material';

/**
 * 代码编辑器组件
 * 基于 Monaco Editor 的代码编辑器
 */
function CodeEditor({
  language = 'python',
  value = '',
  onChange,
  readOnly = false,
  onEditorReady
}) {
  const editorOptions = {
    minimap: { enabled: false },
    fontSize: 13,
    lineNumbers: 'on',
    lineNumbersMinChars: 3,
    scrollBeyondLastLine: false,
    automaticLayout: true,
    tabSize: 4,
    wordWrap: 'off',
    fontFamily: "'Monaco', 'Menlo', 'Consolas', 'Courier New', monospace",
    renderWhitespace: 'selection',
    bracketPairColorization: { enabled: true },
    lineHeight: 19,
    letterSpacing: 0.5,
    readOnly: readOnly,
    domReadOnly: readOnly,
  };

  const handleEditorDidMount = (editor, monaco) => {
    if (onEditorReady) {
      onEditorReady(editor, monaco);
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Monaco Editor */}
      <Box sx={{ flexGrow: 1, position: 'relative', bgcolor: 'white', p: 2, minHeight: 0 }}>
        <Editor
          height="100%"
          language={language}
          value={value}
          onChange={onChange}
          theme="light"
          options={editorOptions}
          onMount={handleEditorDidMount}
        />
      </Box>

      {/* Editor Footer - Status Bar */}
      <Paper
        sx={{
          px: 2,
          py: 0.5,
          borderRadius: 0,
          bgcolor: 'grey.100',
          borderTop: 1,
          borderColor: 'divider',
          minHeight: 36
        }}
        elevation={0}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="caption" color="text.secondary">
            {readOnly ? 'Read Only' : 'Saved'}
          </Typography>
          <Typography variant="caption" fontFamily="monospace" color="text.secondary">
            Ln 1, Col 1
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

export default CodeEditor;

